import React from 'react';

export const Loader: React.FC = () => {
  return (
    <>
      <style>{`
        @keyframes spin-bar {
          0% { opacity: 1; }
          100% { opacity: 0.2; }
        }
      `}</style>
      <div className="flex items-center justify-center w-full h-full">
        <div className="relative" style={{ width: '1em', height: '1em' }}>
          {Array.from({ length: 12 }).map((_, index) => {
            const angle = (index * 30) - 90;
            const opacity = index / 12;
            return (
              <div
                key={index}
                className="absolute bg-current rounded-full"
                style={{
                  width: '7.5%',
                  height: '17.5%',
                  left: '46.25%',
                  top: '5%',
                  transformOrigin: '50% 280%',
                  transform: `rotate(${angle}deg)`,
                  animation: 'spin-bar 1s linear infinite',
                  animationDelay: `${index * (1 / 12)}s`,
                  opacity: 0.2 + opacity * 0.8,
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Loader;
